import { render, staticRenderFns } from "./Programaciones.vue?vue&type=template&id=157f01b6&"
import script from "./Programaciones.vue?vue&type=script&lang=js&"
export * from "./Programaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports